const STORAGE_KEY = "fx_guest_checkout";

export function loadGuestCheckout() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveGuestCheckout({ details, address }) {
  try {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ details: details || null, address: address || null })
    );
  } catch {
    /* quota / private mode */
  }
}

export function clearGuestCheckout() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
